import { DocumentNode, OperationVariables, TypedDocumentNode } from '@apollo/client'
import { utils, writeFile } from 'xlsx'

export interface XlsxColumn {
  header: string
  toStringFunction: (data: any, carriers?: any) => string
}

export interface ExportQuery<TData = any, TVariables = OperationVariables> {
  name: string
  query: DocumentNode | TypedDocumentNode<TData, TVariables>
  variables: TVariables
  context?: any
  action?: string
}

export function writeExportFile(xlsxRows: string[][], fileName: string) {
  const wb = utils.book_new()
  const ws = utils.aoa_to_sheet(xlsxRows)
  utils.book_append_sheet(wb, ws, 'Sheet1')
  writeFile(wb, fileName)
}

export function exportToXlsx(data: any[], xlsxColumns: any[], fileName: string, extraData: any) {
  const xlsxRows = [
    xlsxColumns.map((col: { header: any }) => col.header),
    ...data.map((row: any) =>
      xlsxColumns.map(({ toStringFunction }) => toStringFunction(row, extraData))
    ),
  ]
  writeExportFile(xlsxRows, fileName)
}
